<template>
  <div class="notice-bar">
    <img src="../../assets/img/notice.png" alt="" class="notice-icon" />
    <transition name="slide" mode="out-in">
      <div class="text" :style="{ color: color }" :key="currentIndex">{{ messages[currentIndex] }}</div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    messages: {
      type: Array,
      require: true,
    },
    color: {
      type: String,
      default: '#74A1E3',
    },
    // 滚动速度
    rollTime: {
      type: Number,
      default: 5000,
    },
  },
  data() {
    return {
      currentIndex: 0,
      timer: null,
    }
  },
  mounted() {
    this.startScroll()
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    startScroll() {
      this.timer = setInterval(() => {
        if (!this.messages || !this.messages.length) return
        if (this.currentIndex === this.messages.length - 1) {
          this.currentIndex = 0
        } else {
          this.currentIndex++
        }
      }, this.rollTime)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/charts.scss';
.notice-icon {
  width: vw(18);

  height: vh(18);
  margin-right: vw(9);
}
.notice-bar {
  height: vh(34);
  width: 100%;
  display: flex;
  align-items: center;
  background-image: url('../../assets/img/notice-bg.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding: 0 vw(7);
  box-sizing: border-box;
}
.text {
  flex: 1;
  font-size: rem(13);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.5s linear;
}
.slide-enter {
  transform: translateY(vh(5));
  opacity: 1;
}
.slide-leave-to {
  transform: translateY(vh(-5));
  opacity: 0;
}
</style>
